import { Link } from 'react-router-dom';
import CapabilitiesSection from '../components/CapabilitiesSection';
import CtaBand from '../components/CtaBand';
import CustomSoftwareSection from '../components/CustomSoftwareSection';
import EgrahmantreeProofBand from '../components/EgrahmantreeProofBand';
import EnterpriseScene from '../components/EnterpriseScene';
import HeroProductMosaic from '../components/HeroProductMosaic';
import IndustriesSection from '../components/IndustriesSection';
import ProductOutcomesSection from '../components/ProductOutcomesSection';
import ProductionProofBand from '../components/ProductionProofBand';
import ProductsPortfolioSection from '../components/ProductsPortfolioSection';
import Seo from '../components/Seo';
import StatsBar from '../components/StatsBar';
import WhyMahageetaSection from '../components/WhyMahageetaSection';
import { SITE } from '../config/site';

export default function Home() {
  return (
    <>
      <Seo
        title={`${SITE.shortName} · ${SITE.domain}`}
        description={SITE.description}
        path="/"
      />

      <section className="hero hero--enterprise">
        <EnterpriseScene />
        <div className="container hero__inner">
          <div className="hero__content animate-in">
            <span className="hero__badge">{SITE.legalName}</span>
            <h1 className="hero__title hero__title--single">
              Enterprise software.
              <span className="hero__title-accent"> Built and operated in India.</span>
            </h1>
            <p className="hero__lead">
              {SITE.shortName} designs, ships, and runs <strong>SutraMQ</strong>, <strong>SutraACS</strong>,{' '}
              <strong>MGOpen NMS</strong>, and live marketplace <strong>eGrahmantree</strong> — production
              platforms for IoT, telecom, network operations, and consumer services.
            </p>
            <div className="hero__actions">
              <a href="#products" className="btn btn--primary">
                View products
              </a>
              <Link to="/demo" className="btn btn--glass">
                Request a demo
              </Link>
            </div>
            <p className="hero__trust">
              Product demos available · Live operations in Jaipur · AWS · GCP · Azure
            </p>
          </div>
          <div className="hero__media animate-in animate-in-delay-2">
            <HeroProductMosaic />
          </div>
        </div>
      </section>

      <StatsBar creative />

      <ProductionProofBand />

      <IndustriesSection />

      <ProductOutcomesSection />

      <ProductsPortfolioSection creative compact />

      <EgrahmantreeProofBand />

      <WhyMahageetaSection />

      <CapabilitiesSection limit={3} compact />

      <CustomSoftwareSection compact creative />

      <CtaBand
        creative
        title="Schedule a product consultation"
        description="Demos for SutraMQ, SutraACS, and MGOpen NMS — or discuss a custom AI and cloud engagement with our engineering team."
        primaryLabel="Request a demo"
        primaryHref="/demo"
        primaryExternal={false}
        secondaryLabel="Contact us"
        secondaryTo="/contact"
      />
    </>
  );
}
